import { useAtom } from "jotai";
import {
  businessTypesAtom,
  businessTypesFrontendAtom,
  filterStateAtom,
  savedFiltersStateAtom,
  tagFilterStateAtom,
  userAccessibilityPreferencesAtom,
} from "./atoms";

export function useNearByFilters() {
  const [{ data: businessTypes, isLoading: isTypesLoading }] =
    useAtom(businessTypesAtom);
  const [{ data: businessTypesFrontend, isLoading: isTypesFrontendLoading }] =
    useAtom(businessTypesFrontendAtom);
  const [{ data: userAccessibilityPreferences, isLoading: isPrefsLoading }] =
    useAtom(userAccessibilityPreferencesAtom);

  const [filtersState, setFiltersState] = useAtom(filterStateAtom);
  const [tagFilterState, setTagFilterState] = useAtom(tagFilterStateAtom);
  const [savedFilters, setSavedFilters] = useAtom(savedFiltersStateAtom);

  return {
    businessTypes,
    businessTypesFrontend,
    userAccessibilityPreferences,
    filtersState,
    setFiltersState,
    tagFilterState,
    setTagFilterState,
    savedFilters,
    setSavedFilters,
    isLoading: isTypesLoading || isTypesFrontendLoading || isPrefsLoading,
  };
}
